export const FAQQuestions = [
  {
    question: "What is Frosh?",
    category: "general",
    answer:
      "McGill Engineering Frosh 2026 is a four-day event for new undergraduate Engineering students at McGill. During Frosh, new students get the chance to meet other new students, connect with upper year student-leaders, and get introduced to the McGill Engineering community.",
  },
  {
    question: "When is Frosh?",
    category: "general",
    answer:
      "Frosh 2026 will take place from August 27th - 30th, 2026.",
  },
  {
    question: "What happens during frosh?",
    category: "general",
    answer:
      "Frosh is made up of a variety of social events, completely organized by students.  Students will be attending all events with their group made up of other engineering students, led by upper year student leaders. For a full outline of what happens at each of our events, please refer to our social media posts (instagram @engineeringfrosh) and see the schedule page for last year's schedule for reference.",
  },

  {
    question: "How do I register?",
    category: "registration",
    answer:
      "Registration for all Froshes takes place through the same online system, which you can access through the “Registration” page. Registration is open until August 21st, or until tickets sell out!",
  },
  {
    question: "Why should I do Frosh?",
    category: "general",
    answer:
      "Frosh is your first and best opportunity to get acquainted with the Montreal community, with McGill Engineering, and to kick-start your McGill career. You’ll meet older engineering student mentors and new engineering students like yourself. The friendships you make during Frosh may last through the rest of your McGill career and beyond.",
  },
  {
    question: "How much does Frosh cost?",
    category: "registration",
    answer:
      "The price for this year's frosh is $157 + taxes.",
  },
  {
    question: "Are Frosh events mandatory?",
    category: "general",
    answer:
      "Not at all! We encourage froshies to participate in all Frosh events, but if they can’t make it, or need to take a break that is absolutely okay. Froshies are encouraged to tell their Frosh leaders if they won’t be attending a certain event so they know not to wait for them.",
  },
  {
    question: "Do I have to register?",
    category: "registration",
    answer: "Yes. To attend any Frosh events, you must register online and follow all the steps outlined in our Registration page linked above.",
  },
  {
    question: "I made a mistake on my registration, how can I correct it?",
    category: "registration",
    answer: "Send us an email at oweek@mcgilleus.ca at any time.",
  },

  {
    question: "What is the EUS?",
    category: "EUS",
    answer:
      "The Engineering Undergraduate Society (EUS) is a student-led organization that represents engineering and architecture undergraduate students at McGill University. The EUS supports its students through organized funding for improvement of student life and academics, representation through council, and coordinating an immense amount of opportunities to get involved. Find out more at wiki.mcgilleus.ca, by reading the EUS Handbook that you’ll receive early in the year, or by dropping by the EUS Office in McConnell Room 7!",
  },
  {
    question: "Who are Frosh Coordinators?",
    category: "frosh",
    answer:
      "We are a group of 14 upper-year engineering students who spend their summer organizing the entirety of Frosh. We publicize Frosh to incoming students, find sponsorship, come up with fun events, and hire Frosh Leaders and O-Staff.",
  },
  {
    question: "Who are Leaders and O-Staff?",
    category: "frosh",
    answer:
      "Frosh Leaders are upper-year students who have been hired to guide you throughout Frosh. Your Leaders will also be your mentors throughout your first year at McGill, so be sure to get their contact information during Frosh and hit them up with any questions during or after Frosh! O-Staff are upper-year students who have been hired to help the Coordinators run all of the events at Frosh. They have all received extensive training, so feel free to approach them at any time, and they will be happy to answer your questions!",
  },
  {
    question: "Who are Froshies?",
    category: "frosh",
    answer: "You! A “Froshie” is anyone who is a participant in Frosh.",
  },
  {
    question: "Who can participate in Frosh?",
    category: "general",
    answer:
      "Engineering Frosh is open to any student entering McGill for their first year of an undergraduate degree in Engineering or Architecture, or whose first semester was the Winter 2026 academic semester. Frosh welcomes froshies aged 23 and under, but you only get one chance - you can’t participate in Frosh in any year after your first one (however, you can apply to be a Leader, O-Staff, or Coordinator!). If you are a transfer or exchange student coming to McGill for your first year in Engineering or Architecture, you are welcome to participate in Frosh.",
  },
  {
    question: "I am not in Engineering, can I sign up for Engineering Frosh?",
    category: "registration",
    answer:
      "Probably not. Students are strongly suggested to participate in the Frosh of their faculty, or in a non-Faculty Frosh, so they can make connections with people they will be working alongside throughout their McGill career. If you have unusual circumstances and think that Engineering Frosh would be the best fit for you (e.g. you transferred Faculties after registering for Frosh), send an email to oweek@mcgilleus.ca.",
  },
  {
    question:
      "I have a concern that I would like addressed before registering, how can I contact a Frosh Coordinator?",
    category: "registration",
    answer:
      "Any concerns can be sent to oweek@mcgilleus.ca, and the appropriate Coordinator will reply to your question.",
  },
  {
    question: "Where can I learn more about groups and clubs on campus?",
    category: "EUS",
    answer:
      "You can navigate to the Explore the Board tab to see lists of many different engineering clubs, committees, societies, design teams, and more! There are also a whole bunch of clubs and design teams invited to do presentations and introduce themselves at various frosh events. Additionally, be on the lookout for involvement fairs and a more specific EUS involvement day in the first few weeks of classes.",
  },
  {
    question:
      "What if the price of Frosh is outside of my budget?",
    category: "registration",
    answer:
      "If you require any financial assistance to participate in Frosh, we have bursaries available! To be eligible for a bursary, you must be able to pay for your ticket before applying. If this poses a significant barrier, please email Lucas at oweek.inclusivity@mcgilleus.ca. The bursary can be found in the Registration tab linked above.",
  },
];